/**
 * @returns {string} The current route of the application
 */
const getCurrentRoute = () => {
    const location = window.location;
    if (SETTINGS.NEWUI) {
        // for new UI, next url should be current route including query parameters
        return location.pathname + location.search;
    } else {
        // for old UI, next url should have current hash e.g. `/csoar/ui/#playbook`
        return '/csoar/ui/' + location.hash;
    }
};

/**
 * Redirects an unauthorized user to the Sumo login page
 * @author VO
 */
export const redirectToLoginPage = () => {
    const currentRoute = getCurrentRoute();
    const encodedCurrentRoute = encodeURIComponent(currentRoute);
    // include a "next" query param so that Sumo forwards user back to CSOAR section after login
    location.replace(`${location.origin}/ui/?next=${encodedCurrentRoute}`);
};
